import {observer} from "mobx-react";
import {ReactiveContentItem} from "../../../stores/SchoolFeedStore";
import React, {RefObject} from "react";
import styles from "./styles/NewsModal.module.scss";
import FontAwesome from "../../utilities/FontAwesome";
import {withoutLocaleInURI} from "../../../internationalization/i18nURI";
import {useReactToPrint} from "react-to-print";
import {useStores} from "../../../stores/useStores";
import {useGetDevice} from "../../../hooks/useGetDevice";

type ContentNode = Element | Text | null | undefined;

const NewsModalContentHeader = observer((props: {
    index: number,
    itemObj: ReactiveContentItem | IAccordionItem,
    navigationButtons?: React.ReactElement,
    closeFunction?: () => void,
    printRef: RefObject<ContentNode> | undefined,
    shareUrlPath: string,
}) => {
    const {modalStore, organizationStore} = useStores();
    const contentRef = props.printRef
    const reactToPrintFn = useReactToPrint({ contentRef, documentTitle: organizationStore.organization.title });

    async function onClick() {
        modalStore.addModal({
            type: "shareContentItem",
            url: withoutLocaleInURI("https://" + window.location.host + props.shareUrlPath),
            title: props.itemObj.title
        })
    }

    const handlePrint = () => {
        reactToPrintFn();
    };

    const {isIOS} = useGetDevice();

    return <>
        <header>
            <div>
                <button onClick={props.closeFunction}>
                    <FontAwesome name={"fa-solid fa-times"}/>Close
                </button>
            </div>
            <div className={styles.navButtonsContainer}>
                {props.navigationButtons}
                <div className={styles.sharePrintButtons}>
                    <button onClick={onClick}><FontAwesome name={'fa-external-link-alt'}
                                                           prefix={'fas'}
                                                           aria-label={"Copy link to content"}
                                                           title={"Copy link to content"}/><span>&nbsp;Share</span>
                    </button>
                    {!isIOS && <button onClick={handlePrint}><FontAwesome name={'fa-print'}
                                                               prefix={'fas'}
                                                               aria-label={"Print content"}
                                                               title={"Print content"}/><span>&nbsp;Print</span>
                    </button>}
                </div>
            </div>
        </header>
    </>
})

export default NewsModalContentHeader;
